// eslint-disable-next-line no-restricted-imports
import { Image } from "expo-image";
import { router, usePathname } from "expo-router";
import { View } from "react-native";
import { withUnistyles } from "react-native-unistyles";

import Pressable from "$src/core/components/atoms/Pressable";
import Text from "$src/core/components/atoms/Text/Text";
import type {
  TabBarItem,
  TabBarProps,
} from "$src/core/components/organisms/TabBar/types";
import useAnalytics from "$src/core/hooks/use-analytics";
import useResponsiveImage from "$src/core/hooks/use-responsive-image";

import $, { IMAGE_DIMENSIONS } from "./TabBar.web.styles";

const UniImage = withUnistyles(Image);

const Item = ({ item }: { item: TabBarItem }) => {
  const pathname = usePathname();
  const { trackEvent } = useAnalytics();

  const iconImage = useResponsiveImage(item.icon, {
    dimensions: IMAGE_DIMENSIONS.icon,
  });

  const handlePress = () => {
    router.navigate(`/${item.slug}`);
    trackEvent("button_interaction", {
      button_name: `tab_bar_item_${item.slug}`,
      button_type: "tab_bar_item",
      button_label: item.label,
    });
  };

  const isActive =
    pathname === `/${item.slug}` || pathname.startsWith(`/${item.slug}/`);

  return (
    <Pressable accessibilityRole="tab" onPress={handlePress} style={$.tab}>
      <View style={$.tabInner}>
        <UniImage
          uniProps={(theme) => ({
            tintColor: isActive
              ? theme.colors.foregroundDefault
              : theme.colors.foregroundDefaultMuted,
          })}
          source={iconImage}
          style={$.tabIcon}
          contentFit="contain"
          accessibilityRole="none"
        />
        <Text style={$.tabLabel({ isActive })} accessibilityRole="text">
          {item.label}
        </Text>
      </View>
    </Pressable>
  );
};

const TabBar = ({ style, items }: TabBarProps) => (
  <View style={[$.container, style]} accessibilityRole="tabbar">
    {items.map((item, index) => (
      <Item key={index} item={item} />
    ))}
  </View>
);

export default TabBar;
